// extracted by mini-css-extract-plugin
module.exports = {"fullScreenError":"FullScreenError_fullScreenError__3HweF","errorMsg":"FullScreenError_errorMsg__3HFgi"};